export const defaultData = {
  title: 'Hallo',
  subtitle: 'Hier finden Sie alle Informationen zu Ihrem Teilverkauf.',
  image: {
    alt: '',
    filename: 'https://a.storyblok.com/f/148087/570x180/64cbc10691/dashboard-hero-section.jpg?cv=1666600527788',
  },
};
